import React from "react";
import {
    addItem,
    deleteChangedItem,
    setAllItem,
    sendOrder
} from "../store/actions/cart_actions";
import {connect} from "react-redux";
import {getStep, OrderStatus} from "./OrderIDPage";
import CartItem from "../Components/CartItem";
import {Link, Redirect} from "react-router-dom";
import {basket} from "./Header";
import {getCartData, ResultInfo} from "./CartPage";
import {Checkboxes} from "./CatalogPage";
import {
    action_order,
    action_order_create,
    apiURL, contractId,
    CORSSupport,
    userID,
    userLogin,
    userPassword
} from "../configurationConstant";

class MakeOrder extends React.Component{
    constructor(props){
        super(props);
        this.makeOrder = this.makeOrder.bind(this);
        let items = localStorage.getItem('cart');
        if (items !== null && items.length > 0) {
            items.split(';').forEach(item => {
                if (item !== '') {
                    try {
                        let data = JSON.parse(item);
                        this.props.addItem(data);
                    }catch (e) {}
                }
            })
        }
        this.state = {
            status: getStep('100'),
            all_selected: false,
            on_make_redirect: false
        }
    }

    getOrderData(data){
        let items ='';
        data.forEach((item, index) =>{
            items+='&order_data['+index+'][catalogid]='+item.id;
            items+='&order_data['+index+'][count]='+item.refund;
            item.services.forEach((el,index_service) =>{
                items+='&order_data['+index+'][services]['+index_service+'][catalog_service_id]='+el.id;
                items+='&order_data['+index+'][services]['+index_service+'][count_order]='+el.count;
            })
        });
        return items;
    }


    makeOrder(){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        let data = this.getOrderData(this.props.cart.cart_items);
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_order_create + '&contract=' + contractId + '&log=' + userLogin + '&pwd=' + userPassword + '&user=' + userID + data,

            mode: 'cors',
        }).then(r => {
            if (r.status === 200){
                this.props.sendOrder();
                this.setState({on_make_redirect: true});
                localStorage.setItem('cart', '');
            }
        }).catch(r => console.log(r));
    }

    render(){
        const {cart} = this.props;
        let data = getCartData(cart.cart_items);

        return(
            <main id={'make_order_page'}>
                {this.state.on_make_redirect ? <Redirect to={'/order'} />: undefined}
                <div className={"title_container"}>
                    <p>Заявка</p>
                </div>
                <OrderStatus status={this.state.status.status}/>
                <div className={"title_container"}>
                    <p>{this.state.status.name}</p>
                </div>
                <div className={'make_order'}>
                <div id={'cart_list'}>
                    <div className={"title_container"}>
                        <p>Заявка</p>
                    </div>
                    <div className={'cart_select_position'}>
                        <button onClick={() => {
                            this.setState({all_selected: !this.state.all_selected});
                            this.props.setAllItem(!this.state.all_selected)}}>
                            {Checkboxes(this.state.all_selected)}
                            <p>Выбрать все</p>
                        </button>
                        {cart.chooses_items.length === 0 ? undefined : (
                            <button onClick={() => {
                                this.props.deleteChangedItem()
                            }}>
                                <p>Удалить выбранные</p>
                            </button>
                        ) }
                    </div>
                    <div className={'desktop_cart_table'}>
                        <div>Название</div>
                        <div>Цена за ед. ₽</div>
                        <div>Услуг в заявке</div>
                        <div>Цена ₽</div>
                    </div>
                    <div id={'items'}>
                        {cart.cart_items.map( item => {
                            return (<CartItem item={item} key={item.id}/>)
                        })}
                    </div>
                </div>
                <div id={'cart_result'}>
                    {ResultInfo(cart.cart_items.length, data.positions, data.price,data.bonus)}
                    <div >
                        <div  className={'order_result_info order_payment'}>
                            <div className={'result_title'}>
                                <p>Способ оплаты</p>
                            </div>
                            <div className={'result_line'}/>
                            <div className={'result_position'}>
                                <p>По счету</p>
                            </div>
                        </div>
                        <div className={'order_result_info order_payment'}>
                            <div className={'result_title'}>
                                <p>Доставка</p>
                            </div>
                            <div className={'result_line'}/>
                            <div className={'result_position'}>
                                <p>Способ доставки: Курьером</p>
                            </div>
                            <div className={'result_position'}>
                                <p>Стоимость доставки: 10 000 руб.</p>
                            </div>
                        </div>
                    </div>
                    <div className={'order_result order_repeat'}>
                        <button className={'order_button'} onClick={() => {this.makeOrder()}}>
                            <p>Разместить</p>
                        </button>
                    </div>
                    <div className={'result_add_position back_to_cart'}>
                        <Link to={'/cart'}>
                            <img src={basket} alt={''}/>
                            <p>Вернуться в корзину</p>
                        </Link>
                    </div>
                </div>
            </div>
            </main>
        )
    }
}

const mapStateToProps = store => {
    return{
        cart: store.cart,
    }
};

const mapDispatchToProps = dispatch => {
    return{
        addItem: (id) => dispatch(addItem(id)),
        deleteChangedItem: () => dispatch(deleteChangedItem()),
        setAllItem: (flag) => dispatch(setAllItem(flag)),
        sendOrder: () => dispatch(sendOrder())
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(MakeOrder)
